/**
 * Event Schedule filters — aapke actual API response ke hisaab se.
 *
 *   studio  ->  row.studio_name   ("Dreams Come True Dance", null bhi ho sakta)
 *   session ->  row.ceremony      (1, 2, 3 ... ; 0 / null = koi session nahi)
 *   entry   ->  row.entry         ("1", "2", "2.1", null)
 *
 * Teeno criteria ka behaviour ek jaisa hai: matched rows top par pin,
 * baaki rows apni existing order me neeche.
 */

export const ALL = "all";

export const EMPTY_FILTERS = {
  studio: ALL, // studio_name string
  session: ALL, // ceremony number
  entry: "", // entry number search
};

/* ------------------------------------------------------------------ */
/* Field readers                                                       */
/* ------------------------------------------------------------------ */

export const getStudioName = (row) => (row?.studio_name || "").toString().trim();

export const getCeremony = (row) => {
  const n = Number(row?.ceremony);
  return Number.isFinite(n) && n > 0 ? n : null;
};

export const getSessionLabel = (row) => {
  const n = getCeremony(row);
  return n ? `Session ${n}` : "";
};

export const sessionLabelFor = (ceremony) =>
  ceremony ? `Session ${ceremony}` : "";

export const getEntry = (row) => (row?.entry ?? "").toString().trim();

/* ------------------------------------------------------------------ */
/* Options — duplicates hata kar unique list                           */
/* ------------------------------------------------------------------ */

export const buildFilterOptions = (list = []) => {
  const studioSet = new Set();
  const ceremonySet = new Set();

  (list || []).forEach((row) => {
    const studio = getStudioName(row);
    if (studio) studioSet.add(studio);

    const ceremony = getCeremony(row);
    if (ceremony) ceremonySet.add(ceremony);
  });

  const studios = Array.from(studioSet)
    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }))
    .map((name) => ({ value: name, label: name }));

  // Session 2 < Session 10 (numeric sort, string sort nahi)
  const sessions = Array.from(ceremonySet)
    .sort((a, b) => a - b)
    .map((n) => ({ value: n, label: sessionLabelFor(n) }));

  return { studios, sessions };
};

/* ------------------------------------------------------------------ */
/* Matching                                                            */
/* ------------------------------------------------------------------ */

/**
 * Entry match rule:
 *   "2"   -> "2" aur uske sub-entries "2.1", "2.2" bhi
 *   "2.1" -> sirf "2.1"
 */
export const entryMatches = (row, term) => {
  const needle = (term || "").toString().trim();
  if (!needle) return true;

  const entry = getEntry(row);
  if (!entry) return false;

  return entry === needle || entry.startsWith(`${needle}.`);
};

// export const rowMatchesFilters = (row, filters) => {
//   if (!filters) return true;

//   const studioOn = filters.studio && filters.studio !== ALL;
//   const sessionOn = filters.session && filters.session !== ALL;
//   const entryOn = filters.entry && filters.entry.trim() !== "";

//   // koi filter active hi nahi -> row match maana jaayega (edge case)
//   if (!studioOn && !sessionOn && !entryOn) return true;

//   // OR: kisi bhi active filter se match kare to row top group me aa jaaye
//   if (studioOn && getStudioName(row) === filters.studio) return true;
//   if (sessionOn && getCeremony(row) === Number(filters.session)) return true;
//   if (entryOn && entryMatches(row, filters.entry)) return true;

//   return false;
// };

export const rowMatchesFilters = (row, filters) => {
  if (!filters) return true;

  const studioOn = filters.studio && filters.studio !== ALL;
  const sessionOn = filters.session && filters.session !== ALL;
  const entryOn = filters.entry && filters.entry.trim() !== "";

  // koi filter active nahi hai
  if (!studioOn && !sessionOn && !entryOn) return true;

  // AND condition:
  // jo filter active hai, uska match hona compulsory hai
  if (studioOn && getStudioName(row) !== filters.studio) {
    return false;
  }

  if (sessionOn && getCeremony(row) !== Number(filters.session)) {
    return false;
  }

  if (entryOn && !entryMatches(row, filters.entry)) {
    return false;
  }

  return true;
};

export const isFilterActive = (filters) =>
  Boolean(
    (filters?.studio && filters.studio !== ALL) ||
      (filters?.session && filters.session !== ALL) ||
      (filters?.entry && filters.entry.trim() !== "")
  );

/** Sirf panel wale filters active hain? (chips/label ke liye) */
export const hasPanelFilters = (filters) =>
  Boolean(
    (filters?.studio && filters.studio !== ALL) ||
      (filters?.session && filters.session !== ALL)
  );

/* ------------------------------------------------------------------ */
/* Sorting — matched rows top par, baaki as-it-is neeche               */
/* ------------------------------------------------------------------ */

export const applyFilterSort = (rows = [], filters) => {
  if (!isFilterActive(filters)) {
    return { rows, matchedCount: rows.length, matchedIds: new Set() };
  }

  const matched = [];
  const rest = [];
  const matchedIds = new Set();

  rows.forEach((row) => {
    if (rowMatchesFilters(row, filters)) {
      matched.push(row);
      matchedIds.add(row.id);
    } else {
      rest.push(row);
    }
  });

  return {
    rows: [...matched, ...rest],
    matchedCount: matched.length,
    matchedIds,
  };
};